import moment from 'moment';
import { Global } from '@/Config';

export default (data) => {
  if (data) {
    return moment(String(data), Global.format.parseDateTime).format('HH:mm');
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/filters/PrTimeFilter.js